module.exports = __webpack_public_path__ + "static/donwload-app-store-51c834430d0b43d96aea9d62c7b36a8d.png";